import React from 'react';
import { Header } from '../../row/header';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import AheadPreview from '../../ahead/ahead-preview';
import { SelectRowInspector } from '../../molecules/select-row-inspector';
import { setPageType } from '../../actions/builder-action';

const Story = () => {
  const { publisherId = '' } = useParams();
  const dispatch = useDispatch();
  const subPageType = useSelector((state: any) => get(state, ['builder', 'subPageType'], ''));
  dispatch(setPageType('story'));
  return (
    <div>
      <Header publisherId={publisherId} />
      <AheadPreview hideHeader hideBreakingNews hideFooter={subPageType === 'globalAiElements'} />
      <SelectRowInspector publisherId={publisherId} />
    </div>
  );
};

export default Story;
